"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PageList_component_exports = {};
__export(PageList_component_exports, {
  default: () => PageList_component_default
});
module.exports = __toCommonJS(PageList_component_exports);
var import_react = __toESM(require("react"));
var import_react_i18next = require("react-i18next");
var import_PageList = require("./PageList.styled");
var PageList = /* @__PURE__ */ (0, import_react.forwardRef)(function(_ref, pageListRef) {
  var start = _ref.start, end = _ref.end;
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  return /* @__PURE__ */ import_react.default.createElement(import_PageList.StyledPageList, {
    ref: pageListRef,
    role: "menu",
    "data-testid": "pagelist-selector"
  }, Array.from({
    length: end - start + 1
  }, function(_, i) {
    return start + i;
  }).map(function(element) {
    return /* @__PURE__ */ import_react.default.createElement("li", {
      role: "menuitem",
      tabIndex: 0,
      key: "paginator-popup-page-".concat(element),
      className: "menu-item",
      value: element
    }, "".concat(t("base_glossary_page"), " ").concat(element));
  }));
});
var PageList_component_default = PageList;
//# sourceMappingURL=PageList.component.js.map